import styled from 'styled-components'

export const CustomSlider = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  outline: none;
  transition: background 0.2s;

  /* Estiliza a trilha do slider (a linha de fundo) */
  &::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: 5px;
    background: linear-gradient(
      to right,
      #ffc80a ${ ({ value, max }) => (value / max) * 100 }%,
      #babaca ${ ({ value, max }) => (value / max) * 100 }%
    );
  }

  /* Thumb do slider (o botão que arrasta) */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    background: #ffc80a;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    margin-top: -3px; /* Ajuste para centralizar */
  }

  /* Para Firefox */
  &::-moz-range-track {
    height: 8px;
    border-radius: 5px;
    background: linear-gradient(
      to right,
      #ffc80a ${ ({ value, max }) => (value / max) * 100 }%,
      #babaca ${ ({ value, max }) => (value / max) * 100 }%
    );
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #ffc80a;
    border-radius: 50%;
    cursor: pointer;
  }
`

export const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 70vh;
`

export const LegendContainer = styled.div`
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  max-width: 250px;
  height: 50vh;
  overflow-y: scroll;
`

export const LegendTitle = styled.span`
  display: block;
  margin: 0 0 8px 0;
  font-size: 11px;
  font-weight: bold;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`

export const ColorBox = styled.div`
  width: 20px;
  height: 12px;
  margin-right: 8px;
  background: ${ ({ color }) => color };
  border: 1px solid #ccc;
`